<template>
  <RouterLink
    to="/"
    class="fixed inset-0 bg-background z-20 text-foreground flex items-center justify-center cursor-default">
    <div class="rounded-lg bg-surface m-4 lg:m-0 lg:w-1/2 shadow flex flex-col p-4 lg:gap-8 lg:p-8 cursor-pointer">
      <div>
        <div class="justify-between flex">
          <code>{{ route }}</code>
          <XMarkIcon class="h-5" />
        </div>
        <h3 class="text-base mb-4 lg:text-xl font-semibold">{{ t(content.title) }}</h3>
        <p class="mb-4">
          {{ t(content.subtext) }}
        </p>
        <p class="mb-1">
          <ArrowLeftIcon class="h-4 float-left mt-2 pr-1" /><router-link class="underline" to="/">
            {{ t("Back to the homepage") }}</router-link
          >
        </p>
      </div>
      <CoverPhoto class="rounded-lg" src="not-found" :alt="`not found photo`" />
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
import { CoverPhoto } from "@/components/card";
import { RouterLink } from "vue-router";
import { XMarkIcon, ArrowLeftIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "vue-i18n";
import brandconfig from "@/brandconfig";
const { t } = useI18n();

const route = window.location;

const props = withDefaults(defineProps<{ error?: number | boolean }>(), { error: 500 });

const content = (() => {
  if (props.error == 404) {
    return {
      title: "This page was not found.",
      subtext:
        "The page you were navigating to was not found. Maybe it has been moved or deleted. Our technical team has been notified and will look into this.",
      tabTitle: "Page not found",
    };
  }
  return {
    title: "Something went wrong.",
    subtext:
      "The page you were navigating to encountered an issue. Our technical team has been notified and will look into this.",
    tabTitle: "Error encountered",
  };
})();

document.title = `${t(content.tabTitle)} | ${brandconfig.BRAND}`;
</script>
